module.exports = __webpack_public_path__ + "img/logout.3d2a84df.svg";